export default "__VITE_ASSET__IK2p2u7Y__"